import { ColumnInterface } from '@shared/interfaces/column.interface'
import { PositionColumnsEnum } from '@shared/components/trading/widgets/positions-widget/core/enums/position-columns.enum'

export const PositionColumnsConstant: ColumnInterface<PositionColumnsEnum>[] = [
	{
		column: PositionColumnsEnum.ticker,
		visible: true,
	},
	{
		column: PositionColumnsEnum.marketValue,
		visible: true,
	},
	{
		column: PositionColumnsEnum.quantity,
		visible: true,
	},
	{
		column: PositionColumnsEnum.priceAveragePrice,
		visible: true,
	},
	{
		column: PositionColumnsEnum.share,
		visible: true,
	},
	{
		column: PositionColumnsEnum.profitabilityPerDay,
		visible: true,
	},
	{
		column: PositionColumnsEnum.profitability,
		visible: true,
	},
]
